const EMBED_CANONICAL_PATH = /^\/embed\/[^/]+\/?$/;
const EMBED_USER_STATUS_PATH = /^\/@?[^/]+\/[^/]+\/embed\/?$/;
const EMBED_USER_POSTS_PATH = /^\/@?[^/]+\/posts\/[^/]+\/embed\/?$/;

export const isEmbedPath = (pathname: string): boolean => {
  const normalizedPath = pathname.split(/[?#]/)[0];

  return (
    EMBED_CANONICAL_PATH.test(normalizedPath) ||
    EMBED_USER_STATUS_PATH.test(normalizedPath) ||
    EMBED_USER_POSTS_PATH.test(normalizedPath)
  );
};
